module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-w300 push"
  }, [_c('i', {
    staticClass: "fa fa-users fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.actualGroup.group_name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.actualGroupLevel === 1) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.displayAddGroupToUser = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v("Ajouter un groupe de Niveau 1")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadLiveMonitor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-handshake-o fa-1x push-5-r "
  }), _vm._v("Accepter une invitation de partage")])])])]), _vm._v(" "), (_vm.displayAddGroupToUser) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('create-group-form', {
    attrs: {
      "componentState": "01"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeDisplayAddGroupToUser()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v("Fermer")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), (_vm.actualGroup.permissions.GrpLinkedProfileRead[0]) ? _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-striped remove-margin-b font-s16"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.linked_profile), function(profile) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(profile.email))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(profile.rule.rule_id === 'Full Access') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Plein Accèes")]) : _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Personalisé")])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [(profile.rule.rule_id === 'Full Access') ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Créer un accèes personalisé"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    })]) : _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier les accèes"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _vm._m(2, true)])])])
  }), 0)]), _vm._v(" "), (_vm.actualGroup.permissions.GrpSharingEnable[0]) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadLiveMonitor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v("Inviter un usager au groupe")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.actualGroup.permissions.GrpSubGroupRead[0]) ? _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table table-striped remove-margin-b font-s14"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.sub_group), function(group) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(group.group_name))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(group.sub_group.length))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(group.bundles.length))])])
  }), 0)]), _vm._v(" "), (_vm.actualGroup.permissions.GrpSubGroupWrite[0]) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.displayAddSubGroupToGroup = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v("Ajouter un sous-groupe usagers")])]) : _vm._e(), _vm._v(" "), (_vm.displayAddSubGroupToGroup) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('create-sub-group-form', {
    attrs: {
      "componentState": "01"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeDisplayAddSubGroupToGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v("Fermer")])])], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.actualGroup.permissions.GrpBundleRead[0]) ? _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table table-striped remove-margin-b font-s14"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.bundles), function(bundle) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.bundle_name))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.bundle_type))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.devices.length))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.channels.length))])])
  }), 0)]), _vm._v(" "), (_vm.actualGroup.permissions.GrpSubGroupWrite[0]) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadLiveMonitor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v("Ajouter un groupe système")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm._m(7)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-user fa-2x push-5-r "
  }), _vm._v("Usagers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Usager")]), _vm._v(" "), _c('th', [_vm._v("Type d'accès")]), _vm._v(" "), _c('th', [_vm._v("Accès")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Retirer l'usager"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-users fa-2x push-5-r "
  }), _vm._v("Sous groupes d'usagers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Groupes")]), _vm._v(" "), _c('th', [_vm._v("#Sous Groupes")]), _vm._v(" "), _c('th', [_vm._v("#Groupes Système")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-database fa-2x push-5-r "
  }), _vm._v("Groupes système")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Groupes système")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("#Device")]), _vm._v(" "), _c('th', [_vm._v("#Canaux")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49642202","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/group/Index.vue
// module id = 1525
// module chunks = 4